/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ChangePrescriptionRequestBody,
  ChangePrescriptionRequestBody$Outbound,
  ChangePrescriptionRequestBody$outboundSchema,
} from "../components/changeprescriptionrequestbody.js";

export type PlatformKillswitchesNumberChangePrescriptionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type PlatformKillswitchesNumberChangePrescriptionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  changePrescriptionRequestBody: ChangePrescriptionRequestBody;
};

/** @internal */
export type PlatformKillswitchesNumberChangePrescriptionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const PlatformKillswitchesNumberChangePrescriptionSecurity$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberChangePrescriptionSecurity$Outbound,
    PlatformKillswitchesNumberChangePrescriptionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function platformKillswitchesNumberChangePrescriptionSecurityToJSON(
  platformKillswitchesNumberChangePrescriptionSecurity:
    PlatformKillswitchesNumberChangePrescriptionSecurity,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberChangePrescriptionSecurity$outboundSchema.parse(
      platformKillswitchesNumberChangePrescriptionSecurity,
    ),
  );
}

/** @internal */
export type PlatformKillswitchesNumberChangePrescriptionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  ChangePrescriptionRequestBody: ChangePrescriptionRequestBody$Outbound;
};

/** @internal */
export const PlatformKillswitchesNumberChangePrescriptionRequest$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberChangePrescriptionRequest$Outbound,
    PlatformKillswitchesNumberChangePrescriptionRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      changePrescriptionRequestBody:
        ChangePrescriptionRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        changePrescriptionRequestBody: "ChangePrescriptionRequestBody",
      });
    }),
  );

export function platformKillswitchesNumberChangePrescriptionRequestToJSON(
  platformKillswitchesNumberChangePrescriptionRequest:
    PlatformKillswitchesNumberChangePrescriptionRequest,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberChangePrescriptionRequest$outboundSchema.parse(
      platformKillswitchesNumberChangePrescriptionRequest,
    ),
  );
}
